<template>

    <form>
        <b-modal :active.sync="isComponentModalActive"
                 has-modal-card full-screen >
 
            <div class="modal-card ">
                <section class="modal-card-body"  >
                    <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
                    <template>
                        <section>
                             <!-- {{listOfUsers}} -->
                            <b-tabs  class="block" >
                               <b-tab-item  v-if="userListDisplay">
                                   <template slot="header">
                                       <b-icon icon="account-group"></b-icon>
                                       <span> List of Users</span>
                                   </template>

                                    <b-button type="is-success" icon-left="refresh"  outlined @click="fetchUsers"  ref="refreshUsers" :disabled="isFetchUser"  > Refresh User</b-button>
                                    &nbsp;
<!--                                    <b-button type="is-success" icon-left="account-plus"  outlined @click="addNewUser"  :disabled="isFetchUser" > Add New User</b-button>-->
                                    <hr>
                                    <b-field grouped >
                                        <b-field label="Name" v-if="listOfUsers.length>0">
                                            <b-input   v-model="searchName" placeholder="» » » » สมชาย « « « «"></b-input>
                                        </b-field>
                                        <b-field label="Surname" v-if="listOfUsers.length>0">
                                            <b-input   v-model="searchSurName" placeholder="» » » » กล้าหาญ « « « «"></b-input>
                                        </b-field>
                                        <b-field label="Auth." v-if="authGroups.length>0">
                                            <b-select placeholder="Select a Auth." v-model="authGroupSelected">
                                                <option
                                                        v-for="authGroup in authGroups"
                                                        :value="authGroup.id"
                                                        :key="authGroup.id">
                                                    {{ authGroup.name }}
                                                </option>
                                            </b-select>
                                        </b-field>

                                        <b-field label="clear" v-if="listOfUsers.length>0">
                                            <b-button type="is-danger" outlined  icon-right="close"  @click="clearModel" />
                                        </b-field>
                                    </b-field>
                                    <br>
                                    <hr>
                                                <b-table
                                                        :data="isEmpty ? [] : listOfUsersFilter"
                                                        bordered
                                                        striped
                                                        narrowed
                                                        hoverable
                                                        :loading="isTblLoading"
                                                        mobile-cards
                                                        :paginated="isPaginated"
                                                        :per-page="perPage"
                                                        :current-page.sync="currentPage"
                                                        >


                                                        <b-table-column  label=""  centered v-slot="props">
                                                            <b-tooltip label="Edit User Profile">
                                                            <b-button type="is-info"  icon-right="account-edit" @click="editUser(props.row.iduser)" />
                                                            </b-tooltip>
                                                           &nbsp;<b-tooltip label="Reset/Set User Password">
                                                            <b-button type="is-info"  icon-right="lock-reset" @click="setPassword(props.row.iduser)" />
                                                            </b-tooltip>
                                                        </b-table-column>

                                                        <b-table-column  label="Name"  v-slot="props" >
                                                           {{props.row.name}}
                                                        </b-table-column>

                                                        <b-table-column  label="Surname"   v-slot="props">
                                                            {{props.row.surname}}
                                                        </b-table-column>

                                                        <b-table-column   label="Username (for Local HIS)"   v-slot="props" >
                                                            {{props.row.username}} 
                                                        </b-table-column>


                                                        <b-table-column  label="Email"  v-slot="props" >
                                                            {{props.row.email}}
                                                        </b-table-column>

                                                        <!-- <b-table-column  label="Line Token"  v-slot="props" >
                                                            <b-tooltip   multilined>
                                                                   <template v-slot:content>
                                                                        <i>ทดสอบส่ง Line</i> ถึง <b> {{props.row.name}}</b>.
                                                                    </template>
                                                                <b-button type="is-success"
                                                                    v-if="props.row.line_token"
                                                                    @click="testSendToLine(props.row.line_token, props.row.name , props.row.surname)"
                                                                    icon-right="check-bold" />
                                                            </b-tooltip>   
                                                        </b-table-column>        -->
                                                            <!-- <b-icon
                                                                :icon="props.row.line_token ?  'check-bold' : ''  "
                                                                size="is-medium"
                                                                :type="props.row.line_token ?  'is-success' : 'is-danger'  ">
                                                            </b-icon>    -->
                                                            <!-- {{props.row.line_token}} -->
                                                         

                                                        <b-table-column  label="Auth."  v-slot="props"  >
                                                            {{props.row.name_auth_group}}
                                                        </b-table-column>


                                                        <b-table-column  label="Avatar"  v-slot="props" >
                                                            <figure class="image is-48x48">
                                                            <img  :src="props.row.avartar_path" alt="Image" v-if="props.row.avartar_path.length>0">
                                                            </figure> &nbsp;
                                                        </b-table-column>






                                                    <template slot="empty">
                                                        <section class="section">
                                                            <div class="content has-text-grey has-text-centered">
                                                                <p>
                                                                    <b-icon
                                                                            icon="emoticon-sad"
                                                                            size="is-large">
                                                                    </b-icon>
                                                                </p>
                                                                <p>Nothing here.</p>
                                                            </div>
                                                        </section>
                                                    </template>
                                                </b-table>
                                </b-tab-item>

                                <b-tab-item   v-if="userDetailDisplay"  >
                                    <template slot="header">
                                        <b-icon icon="account-plus"></b-icon>
                                        <span> User <b-tag type="is-info" rounded> {{detailUserMode.txt}} </b-tag> </span>
                                    </template>
                                    <b-button type="is-danger" icon-left="arrow-left"  outlined  @click="setTabActive(0)"  > Back</b-button>
                                    &nbsp;&nbsp;
                                    <b-button type="is-info" icon-left="content-save-outline" @click="saveDat" outlined  v-if="detailUserMode.mode === 0" > Save</b-button>

                                    <b-button type="is-info" icon-left="content-save-outline" @click="updateDat" outlined  v-if="detailUserMode.mode === 1" > Update Data</b-button>
                                    &nbsp;
                                    <b-button type="is-success" icon-left="autorenew"  outlined  @click="clearData"  > Clear All</b-button>
                                    &nbsp;
                                    <b-button type="is-success" icon-left="autorenew"  outlined  @click="clearAvartar" v-if="file" > Clear Avartar (only)</b-button>

                                    <template>
                                        <section>


                                            <b-field label="Name"
                                                     :type="{ 'is-danger': !this.$v.name.required && !first}"
                                                     :message="{ 'Name is require':  !this.$v.name.required && !first }"
                                            >
                                                <b-input v-model="name" disabled></b-input>

                                            </b-field>

                                            <b-field label="Surname" >
                                                <b-input v-model="surname" disabled></b-input>
                                            </b-field>

                                            <b-field label="Username (for local HIS)">
                                                <b-input v-model="username" disabled></b-input>
                                            </b-field>

                                            <b-field label="Email"
                                                     :type="{ 'is-danger': ( !this.$v.emailAddress.required ||  !this.$v.emailAddress.email ) && !first}"
                                                     :message="{ 'Email have require and failure to validations': ( !this.$v.emailAddress.required || !this.$v.emailAddress.email ) && !first }"
                                            >
                                                <b-input v-model="emailAddress"></b-input>
                                            </b-field>


                                            <b-field grouped>
                                                <b-field expanded>
                                                    <template #label>
                                                        Line Token #1 <span class="has-text-primary is-italic"><b-switch size="is-small" v-model="userHasLineToken_0"></b-switch></span>
                                                    </template>
                                                    <b-input v-model="lineToken_0" :disabled="!userHasLineToken_0"></b-input>
                                                </b-field>

                                                <b-field expanded>
                                                    <template #label>
                                                        Description #1
                                                    </template>
                                                    <b-input v-model="descpLineToken_0" :disabled="!userHasLineToken_0"></b-input>
                                                </b-field>
                                            </b-field>



                                            <b-field grouped>
                                                <b-field expanded>
                                                    <template #label>
                                                        Line Token #2 <span class="has-text-primary is-italic"><b-switch size="is-small" v-model="userHasLineToken_1"></b-switch></span>
                                                    </template>
                                                    <b-input v-model="lineToken_1" :disabled="!userHasLineToken_1"></b-input>
                                                </b-field>

                                                <b-field expanded>
                                                    <template #label>
                                                        Description #2
                                                    </template>
                                                    <b-input v-model="descpLineToken_1" :disabled="!userHasLineToken_1"></b-input>
                                                </b-field>
                                            </b-field>



                                            <b-field grouped>
                                                <b-field expanded>
                                                    <template #label>
                                                        Line Token #3 <span class="has-text-primary is-italic"><b-switch size="is-small" v-model="userHasLineToken_2"></b-switch></span>
                                                    </template>
                                                    <b-input v-model="lineToken_2" :disabled="!userHasLineToken_2"></b-input>
                                                </b-field>

                                                <b-field expanded>
                                                    <template #label>
                                                        Description #3
                                                    </template>
                                                    <b-input v-model="descpLineToken_2" :disabled="!userHasLineToken_2"></b-input>
                                                </b-field>
                                            </b-field>









                                            <b-field label="Auth.">
                                                <b-select placeholder="Select a Auth." v-model="IDLAB_AUTHGROUP" >
                                                    <option
                                                            v-for="authGroup in authGroups"
                                                            :value="authGroup.id"
                                                            :key="authGroup.id">
                                                        {{ authGroup.name }}
                                                    </option>
                                                </b-select>
                                            </b-field>


                                            <b-field label="Avartar">
                                                <hr>


                                            </b-field>


                                            <b-field label="" >
                                                <div v-if="message"
                                                     :class="`message ${error} ? 'is-danger' : 'is-success' ` ">
                                                    <div class="message-body">{{message}}</div>
                                                </div>
                                                <div class="field">
                                                    <div class="file is-boxed is-primary">
                                                        <label class="file-label">
                                                            <input
                                                                    type="file"
                                                                    ref="file"
                                                                    @change="selectFileAndUp"
                                                                    class="file-input"
                                                            >
                                                            <span class="file-cta">
                                                             <span class="file-icon">
                                                                 <i class="fas fa-upload"></i>
                                                             </span>
                                                             <span class="file-label">
                                                               Choose a file...
                                                             </span>
                                                         </span>
                                                            <span v-if="file" class="file-name">{{file.name}}</span>
                                                        </label>
                                                    </div>
                                                </div>

                                            </b-field>
                                            <b-field label="" >
                                                <figure class="image is-128x128" v-if="urlTempUploaded.length">
                                                    <img  :src="urlTempUploaded" alt="Image" v-if="urlTempUploaded.length>0">
                                                </figure>


                                            </b-field>

                                        </section>
                                    </template>

<!--                                    <DlgEditFolderName v-if="isModalEditFolderName" @close="closeDlgEditFolderName"  @closeWithChange="closeDlgEditFolderNameWithChange" :dataToChild=dataToDelOrRename></DlgEditFolderName>-->
                                </b-tab-item>
                            </b-tabs>

                        </section>
                        <DlgResetPassword v-if="isModalPasswordReset" @close="closeOnly"   :dataToChild=userIdToResetPass ref="DlgResetPassword" ></DlgResetPassword>
                    </template>


                </section>
                <footer class="modal-card-foot">
                    <b-button size="is-medium" type="is-danger"
                              icon-left="close" @click="closeModal">
                        Close
                    </b-button>
                </footer>
            </div>

        </b-modal>
    </form>
</template>

<script>
    /* eslint-disable no-console */
    import axios from "axios"
    import { getBaseURLforBackEnd  , getConfigAxios , getBaseURLAvartar }  from '@/utils.js'
    import { required , email} from 'vuelidate/lib/validators'
    import DlgResetPassword from "./DlgResetPassword";
    import { mapState } from "vuex";



   const TXT_ADD_NEW = "Add New"
   const TXT_EDIT_USER = "Edit "


    export default {
        name: "UserManagement",
        components:{
            DlgResetPassword
        },
        created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.closeModal()

                next(false)
            })

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
        },
        props:{
            isComponentModalActive: Boolean,
        },
        validations:{
            name :{
                required
            },
            emailAddress:{
                required,
                email
            }
        },
        computed:{
             ...mapState({
                access_token: state => state.master_data.access_token,
            }),
            listOfUsersFilter: function () {

               return this.listOfUsers.filter((listOfUser)=>{
                   // console.log(listOfUser.id_auth_group)
                  return listOfUser.name.indexOf(this.searchName) > -1
                         && listOfUser.surname.indexOf(this.searchSurName) > -1
                         && listOfUser.id_auth_group  === this.authGroupSelected
               })
            }
        },
        data(){
            return {
                listOfUsers : [] ,
                isFetchUser : false ,
                isTblLoading : false ,
                searchName : "",
                searchSurName : "",
                isEmpty: false,
                isFullScreenLoading : false,

                isPaginated: true,
                isPaginationSimple: false,
                paginationPosition: 'bottom',
                currentPage: 1,
                perPage: 15 ,



                userListDisplay : true,
                userDetailDisplay: false,


                file:"",
                message: "",
                error : false,


                name: "",
                surname: "",
                username: "",
                emailAddress: "" ,
                lineToken_0 : "",
                descpLineToken_0 : "",
                lineToken_1 : "",
                descpLineToken_1 : "",
                lineToken_2 : "",
                descpLineToken_2 : "",
                IDLAB_AUTHGROUP : "",
                urlTempUploaded: "",
                fileNameUploaded:"",


                first : true ,

                detailUserMode : { txt : '', mode : 0 , iduser_foredit : null} , // 0 = add new , 1 = edit

                isModalPasswordReset: false,
                userIdToResetPass : '' ,
                authGroups:[],
                authGroupSelected : "",


                userHasLineToken_0 : false,
                userHasLineToken_1 : false,
                userHasLineToken_2 : false,
            }
        },
        methods:{

        testSendToLine(lineToken,user_n,user_sn){
            // console.log(lineToken)

            const datTo = {
                "line_token" : lineToken ,
                "to_user" : `${user_n} ${user_sn}`
            } 
            axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
            axios.post(`${getBaseURLforBackEnd()}/api/dosendlinetest`,datTo,getConfigAxios())
             .then(()=>{
             })
        },
        clearModel(){
            this.searchName = ""
            this.searchSurName = ""
            this.authGroupSelected = ""
        },
        loadAuthGroup(){
            const datTo ={
                "all" : false
            }
            const vm = this
            axios.post(`${getBaseURLforBackEnd()}/api/listofauthgroup`,datTo,getConfigAxios())
                .then((res)=>{
                    vm.authGroups = res.data
                })
                .catch((err)=>{
                    console.log(err)
                })
        },
        closeOnly(){
                this.isModalPasswordReset = false
         },
         setPassword(userId){

             this.userIdToResetPass = userId
             // console.log(userId)
             this.isModalPasswordReset = true
             // this.$refs.DlgResetPassword.first = true
             // console.log('setPassword')
         },
         async updateDat(){
                      if(!this.$v.name.required || !this.$v.emailAddress.required || !this.$v.emailAddress.email){
                          // console.log('error name required')
                          this.first = false
                      }else {
                           //   console.log('ok')
                           //   console.log(this.lineToken_0)
                          const dat = {
                              "iduser" : this.detailUserMode.iduser_foredit ,
                              "name" : this.name,
                              "surname" : this.surname,
                              "email":  this.emailAddress,
                              "line_token_0" : this.userHasLineToken_0  ? this.lineToken_0  : null   ,
                              "descplinetoken_0" : this.userHasLineToken_0  ? this.descpLineToken_0  : null   ,
                              "line_token_1" : this.userHasLineToken_1  ? this.lineToken_1  : null   ,
                              "descplinetoken_1" : this.userHasLineToken_0  ? this.descpLineToken_1  : null   ,
                              "line_token_2" : this.userHasLineToken_2  ? this.lineToken_2  : null   ,
                              "descplinetoken_2" : this.userHasLineToken_0  ? this.descpLineToken_2  : null   ,
                              "idlab_authgroup" :   this.IDLAB_AUTHGROUP === "" ? null :  this.IDLAB_AUTHGROUP ,
                              "file_avartar": this.fileNameUploaded
                          }
                        //   console.log(JSON.stringify(dat))    
                          const vm = this
                          this.isFullScreenLoading = true
                          await axios.post(`${getBaseURLforBackEnd()}/api/updateuser`,dat,getConfigAxios())
                              .then((res)=>{
                                  vm.isFullScreenLoading = false
                                  vm.$buefy.dialog.alert({
                                      title: 'Success to update',
                                      message: ` ${res.data.dat}` ,
                                      type: 'is-success',
                                      hasIcon: true,
                                      // icon: 'content-save',
                                      // iconPack: 'fa',
                                      // ariaRole: 'alertdialog',
                                      // ariaModal: true
                                  })
                                  vm.clearData()
                                  vm.setTabActive(0)
                                  vm.fetchUsers()
                              })
                              .catch(function(error) {
                                  if (error.response && error.response.status === 401) {
                                      vm.isFullScreenLoading = false
                                      vm.$buefy.dialog.alert({
                                          title: 'Error',
                                          message: `Error ${error.response.data.dat}` ,
                                          type: 'is-danger',
                                          hasIcon: true,
                                          icon: 'times-circle',
                                          iconPack: 'fa',
                                          ariaRole: 'alertdialog',
                                          ariaModal: true
                                      })

                                  }

                              })
                              .finally(()=>{
                                  vm.isTblLoading = false
                              })
                      }
            },
          setTabActive(idx){
              if(idx===0){
                  this.userListDisplay = true,
                  this.userDetailDisplay= false
              }else{
                  this.userListDisplay = false,
                  this.userDetailDisplay= true
              }
          },
          clearData(){
                  this.name= ""
                  this.surname= ""
                  this.username= ""
                  this.emailAddress= ""
                  this.urlTempUploaded = ""
                  this.fileNameUploaded=""

                  this.first = true

                  this.file=""
                  this.message= ""
                  this.error = false
          },
          clearAvartar(){
                 this.file=""
                 this.message= ""
                 this.error = false
                 this.urlTempUploaded =""
                 this.fileNameUploaded=""
           },
            async saveDat(){
              if(!this.$v.name.required || !this.$v.emailAddress.required || !this.$v.emailAddress.email){
                  console.log('error name required')
                  this.first = false
              }else{
                  // console.log('ok')
                   const dat = {
                       "name" : this.name,
                       "surname" : this.surname,
                       "email":  this.emailAddress,
                       "file_avartar": this.fileNameUploaded
                   }

                   const vm = this
                   this.isFullScreenLoading = true
                   await axios.post(`${getBaseURLforBackEnd()}/api/signup`,dat,getConfigAxios())
                      .then((res)=>{
                          vm.isFullScreenLoading = false
                          vm.$buefy.dialog.alert({
                              title: 'Success',
                              message: ` ${res.data.dat}` ,
                              type: 'is-success',
                              hasIcon: true,
                              // icon: 'content-save',
                              // iconPack: 'fa',
                              // ariaRole: 'alertdialog',
                              // ariaModal: true
                          })
                           vm.clearData()
                           vm.setTabActive(0)
                           vm.fetchUsers()
                      })
                      .catch(function(error) {
                          if (error.response && error.response.status === 401) {
                              vm.isFullScreenLoading = false
                              vm.$buefy.dialog.alert({
                                  title: 'Error',
                                  message: `Error ${error.response.data.dat}` ,
                                  type: 'is-danger',
                                  hasIcon: true,
                                  icon: 'times-circle',
                                  iconPack: 'fa',
                                  ariaRole: 'alertdialog',
                                  ariaModal: true
                              })

                          }

                      })
                      .finally(()=>{
                          vm.isTblLoading = false
                      })

              }
          },
          async selectFileAndUp(){
                const file = this.$refs.file.files[0]
                const allowedTypes = ["image/jpeg","image/png","image/gif","image/jpg"]
                const MAX_SIZE = 20000000
                const tooLarge = file.size > MAX_SIZE

                if(allowedTypes.includes(file.type) && !tooLarge){
                    this.file = file
                    this.message = ""
                    this.error = false
                     // console.log('ok')

                    const formData = new FormData()
                    const vm = this
                    formData.append('file',this.file)
                    formData.append('dat','{ "mode": 1}')
                    try{
                        axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                        await axios.post(`${getBaseURLforBackEnd()}/api/upload_avartar`,formData,getConfigAxios())
                                     .then((res)=>{
                                        console.log(res)
                                        vm.urlTempUploaded = res.data.temp_url
                                        vm.fileNameUploaded = res.data.file_name
                                     })

                        // this.file = ""
                        this.error = false
                    }catch (e) {
                        console.log(' error : '+e)
                        this.message = e.response.data.error
                        this.error = true
                    }


                }else{
                    this.message = tooLarge ? `Max size ${MAX_SIZE/1000} kb` : "Only images are allow (from Client)"
                    this.error = true
                }

            },
           editUser(iduser){
               this.setTabActive(1)
               this.detailUserMode.mode = 1  // edit mode
               this.detailUserMode.iduser_foredit = iduser
               this.detailUserMode.txt =  TXT_EDIT_USER+' '+this.name+'  '+this.surname
               const user =  this.listOfUsers.find(user => user.iduser === iduser)
               if(user){
                    this.name = user.name
                    this.surname = user.surname
                    this.username = user.username
                    this.emailAddress = user.email
                    this.lineToken_0 = user.line_token_0
                    this.descpLineToken_0 = user.desc_line_token_0
                    this.lineToken_1 = user.line_token_1
                    this.descpLineToken_1 = user.desc_line_token_1
                    this.lineToken_2 = user.line_token_2
                    this.descpLineToken_2 = user.desc_line_token_2
                  
                    this.userHasLineToken_0 = user.line_token_0 !== null  
                    this.userHasLineToken_1 = user.line_token_1 !== null  
                    this.userHasLineToken_2 = user.line_token_2 !== null  
                    // console.log('--->',user.line_token);
                    this.IDLAB_AUTHGROUP = user.id_auth_group
                    this.urlTempUploaded = user.avartar_path
                }
              
            
               // console.log(JSON.stringify(user))
               // console.log(user.idlab_authgroup)



            },
           addNewUser(){
               this.setTabActive(1)
               this.detailUserMode.mode = 0  // add mode
               this.detailUserMode.txt =  TXT_ADD_NEW
               this.clearData()
            },
           async fetchUsers(){
                   const vm = this
                   this.isFetchUser = true
                   this.isTblLoading = true
                   // clear
                   this.searchName = ''
                   this.searchSurName = ''
                   axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                  await axios.get(`${getBaseURLforBackEnd()}/api/listofuser` , getConfigAxios())
                    .then((res) => {
                         vm.listOfUsers = res.data
                         vm.isFetchUser = false
                         vm.isTblLoading = false
                    })
                    .catch(()=>{
                        vm.$router.push('/login')
                        vm.isFullScreenSearching = false
                    })
                 this.listOfUsers.forEach(dat=>{
                     if(dat.avartar_path){
                         dat.avartar_path =  `${getBaseURLAvartar()}/user_${dat.iduser}/${dat.avartar_path}`
                     }
                 })

                  // load auth group type for filter
                  this.loadAuthGroup()
            },
            closeModal(){
                // this.isComponentModalActive = false
                this.$emit('closeUserManagement')
            }
        },

    }
</script>

<style scoped>
    .b-icon{
        cursor: pointer ;
    }
</style>